import React, { useCallback, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import T from 'prop-types';

import PubContribution from './PubContribution';
import Header from '../Header';
import PreHeader from '../PreHeader';
import DriversQV from '../DriversQV';

import { openPubQuickView } from '../../../actions';
import {
  activeEntitySelector,
  quickViewDataSelector,
  quickViewSettingsSelector,
} from '../../../selectors';
import { ASSET } from '../../../configs/constants';

const { company_data, drivers, pub_contribution } = ASSET;

const emptyObject = {};

const DefaultQVContent = ({ onClose }) => {
  const dispatch = useDispatch();

  const data = useSelector(quickViewDataSelector);
  const { cqv } = useSelector(quickViewSettingsSelector);
  const activeEntity = useSelector(activeEntitySelector);

  const companyData = data[company_data] || emptyObject;
  const activeCompanyData = useMemo(
    () => ({
      ...activeEntity,
      ...companyData,
    }),
    [companyData, activeEntity]
  );

  const driversSettings = {
    ...cqv[drivers],
    pending: cqv[company_data].pending || cqv[drivers].pending,
  };
  const pubContributionSettings = {
    ...cqv[pub_contribution],
    pending: cqv[company_data].pending || cqv[pub_contribution].pending,
  };

  const handlePubQuickViewOpen = useCallback((pub) => dispatch(openPubQuickView(pub)), []);

  return (
    <>
      <PreHeader companyData={activeCompanyData} settings={cqv[company_data]} onClose={onClose} />
      <div className="company-quick-view__scrollable-container">
        <Header companyData={activeCompanyData} settings={cqv[company_data]} onClose={onClose} />
        <div className="company-quick-view__finance-content-wrapper">
          <DriversQV data={data[drivers]} settings={driversSettings} />

          <PubContribution
            data={data[pub_contribution]}
            settings={pubContributionSettings}
            onPubQuickViewOpen={handlePubQuickViewOpen}
          />
        </div>
      </div>
    </>
  );
};

DefaultQVContent.propTypes = {
  onClose: T.func.isRequired,
};

export default DefaultQVContent;
